<template>
    <div class="calendar-bundle calendar-bundle-app-wrapper" :class="isComda ? 'comda' : 'mlp'">
        <div class="calendar-bundle__head" :style="{'background': isComda ? '#1754a3' : '#009444'}">
            <div class="calendar-bundle__head-wrap">
                <div class="calendar-bundle__head-col">
                    <div class="calendar-bundle__head-text--big"
                         :style="{'font-family': isComda ? 'Montserrat' : 'museo', 'color': isComda ? '#f8c22c' : '#fff'}"
                    >
                        {{ store.title }}
                    </div>
                    <div class="calendar-bundle__head-text--small"
                         :style="{'font-family': isComda ? 'Montserrat' : 'museo', 'color': isComda ? '#fff' : '#fff'}"
                    >
                         Mix-and-Match any title in increments of
                        <span class="calendar-bundle__head-text--small-yellow">25</span>
                        to create your bundle. <br>Minimum total quantity of
                        <span class="calendar-bundle__head-text--small-yellow">{{ minBundleQty }}</span>
                        required.
                    </div>
                </div>
                <div class="calendar-bundle__head-col calendar-bundle__head-col--btn">
                    <button
                        v-if="isCalBundlleOpened"
                        :class="isComda ? 'comda-calendar-bundle__head-button' : 'mlp-calendar-bundle__head-button'"
                        @click="calendarBundleToggle"
                    >
                        Click here to hide your current bundle
                    </button>
                    <button
                        v-if="!isCalBundlleOpened"
                        :class="isComda ? 'comda-calendar-bundle__head-button' : 'mlp-calendar-bundle__head-button'"
                        @click="calendarBundleToggle"
                    >
                        Click here to view your current bundle
                    </button>
                </div>
            </div>
        </div>
        <div class="calendar-bundle__body" :style="!isCalBundlleOpened ? 'display: none;' : 'display: flex;'">
            <template v-if="!hasBundleProducts">
                <div class="calendar-bundle__body-wrap">
                    <div :class="isComda ? 'comda-calendar-bundle__body-title' : 'mlp-calendar-bundle__body-title'">
                        {{ calendarBundleBodyTitle }}
                    </div>
                    <div :class="isComda ? 'comda-calendar-bundle__body-items' : 'mlp-calendar-bundle__body-items'">
                        <ul class="calendar-bundle__body-items-list calendar-bundle__list">
                            <li class="calendar-bundle__list-item" v-for="(item, index) in calendarBundleBodyList" :key="index">
                                <div class="calendar-bundle__list-text">{{ item.text }}</div>
                                <div class="calendar-bundle__list-sub_text">{{ item.subText }}</div>
                            </li>
                        </ul>
                        <div class="calendar-bundle__list--bottom-text"> 
                            To view more information about the title you are interested in, click on the title’s name or image.
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="store.bandleProductLists.length">
                <div class="calendar-bundle__body-wrap with-products bandle-products" style="overflow-x: auto;">
                    <template v-for="(product, index) in store.bandleProductLists" :key="index">
                        <ProductTemplate
                            :product="product"
                            :prQty="product.qty"
                            :productListIndex="index"
                            @productRemoved="updatedProductTemplate"
                            @productQtyUpdated="onQtyUpdated"
                        >
                        </ProductTemplate>
                    </template>
                </div>
            </template>
        </div>
        <div class="calendar-bundle__footer" v-if="isCalBundlleOpened">
            <div class="calendar-bundle__footer-wrap">
                <div>
                    <button
                        class="calendar-bundle__footer-btn"
                        :class="totalQty < minBundleQty ? 'calendar-bundle__footer-btn--disabled' : ''"
                        @click="goToCustomizePage"
                    >
                        Customize Your Calendars
                    </button>
                </div>
                <div class="calendar-bundle__footer-text">
                    <template v-if="totalQty < minBundleQty">
                        Add <b>{{ minBundleQty - totalQty }}</b> titles to reach your minimum total quantity of <b>{{ minBundleQty }}</b>
                    </template>

                    <template v-else>
                        Minimum total quantity requirements met!
                    </template>
                </div>
                <div class="calendar-bundle__footer-calc">
                   <FooterCalculation
                    :total-qty="totalQty"
                    :price-by-qty="priceByQty"
                   >
                   </FooterCalculation>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


//import axios from 'axios';
import { store } from './store.js';
import ProductTemplate from './ProductTemplate.vue';
import FooterCalculation from './FooterCalculation.vue';
import storageService from "@/services/storageService";

export default {
    components: {
        ProductTemplate,
        FooterCalculation
    },
    data() {
        return {
            minBundleQty: 100,
            isCalBundlleOpened: false,
            store: store,
            storageService: storageService,
            full_product: null,
            calendarBundleBodyTitle: 'Easily Mix and Match Calendar Titles on One Order:',
            calendarBundleBodyList: [
                {
                    text: "1. Choose which calendars you would like to add.",
                    subText: ""
                },
                {
                    text: "2. Choose your quantity by clicking on the '+' and '-' buttons or by typing in a quantity.",
                    subText: "The quantity must be an increment of 25. If your typed amount does not equal an increment of 25, it will be automatically adjusted to the nearest increment."
                },
                {
                    text: " 3. Click 'Add to Bundle' and your selection will appear here.",
                    subText: ""
                },
                {
                    text: "4. Once you have met the minimum quantity requirements, the 'Customize your Calendars' button will become active.",
                    subText: "You will then be able to add your imprint to your selected calendars."

                }
            ],
            footerCalcList: [
                {
                    key: 'Unit Price:',
                    val: '$0.00 / Each'
                },
                {
                    key: 'Total Quantity:',
                    val: '0'
                },
                {
                    key: 'Sub-Total:',
                    val: '$0.00'
                }
            ],
            hasBundleProducts: false,
            totalQty: 0,
            priceByQty: 0.00,
            tier_data: null,
            singlePrItem: {
                id: null,
                image: null,
                title: null,
                qty: null,
                unitPrice: 0.00
            },
            qtyIterator: 25
        }
    },
    computed: {
      isComda() {
        return window.location.href.includes('comda');
      },
    },
    methods: {
        updatedProductTemplate(val) {
            console.error("product template updated");
            console.log(val);
            if(!this.store.bandleProductLists.length) {
                this.hasBundleProducts = false;
                this.onQtyUpdated({value: 0.00, prIndex: 0, prID: 0 }, 'recalculate');
            } else {
                this.onQtyUpdated({value: 0.00, prIndex: 0, prID: 0 }, 'recalculate');
            }
        },
        calendarBundleToggle() {
            this.isCalBundlleOpened = !this.isCalBundlleOpened;
        },

        getFullProductJson(productID) {
            this.full_product = null;
            productID = 'calendar-gruped';
            console.warn("!!!!!!!!!!window.jQuery(.full_product_info_json-productID)");
            console.warn(".full_product_info_json-" + productID);
            console.warn(window.jQuery(".full_product_info_json-" + productID));
            if(window.jQuery(".full_product_info_json-" + productID) && window.jQuery(".full_product_info_json-" + productID).length) {
                this.full_product = JSON.parse(window.jQuery(".full_product_info_json-" + productID)[0].textContent);
            }
            console.warn("-----> Start Full Json // ImprintTabs.vue");
            console.log(this.full_product);
            console.warn("-----> End Full Json");
            if(this.full_product) {
                this.setTierData();
            }
        },
        getWallFullProductJson() {
            this.full_product = null;
            if(window.jQuery("#full_product_info_json--wall")) {
                this.full_product = JSON.parse(window.jQuery("#full_product_info_json--wall").text());
            }
            console.warn("-----> Start Full Json // ImprintTabs.vue");
            console.log(this.full_product);
            console.warn("-----> End Full Json");
            if(this.full_product) {
                this.setTierData();
            }
        },
        /**
         * Get the effective price of the first (lowest QtyMin) tier for a given SKU.
         * Uses sale_price if it's currently valid, otherwise falls back to price.
         * Used to find the cheapest SKU on init.
         */
        getFirstTierEffectivePrice(tierPrices) {
            if (!tierPrices || !tierPrices.length) return Infinity;

            // Filter out MSRP rows, sort by QtyMin ascending — first = lowest tier
            const validTiers = tierPrices
                .filter(t => t.QtyMin !== 'MSRP')
                .sort((a, b) => Number(a.QtyMin || 0) - Number(b.QtyMin || 0));

            if (!validTiers.length) return Infinity;

            const firstTier = validTiers[0];

            if (this.isSalePriceValid(firstTier)) {
                console.log('[FixedBandle] getFirstTierEffectivePrice → sale_price:', firstTier.sale_price);
                return parseFloat(firstTier.sale_price);
            }

            console.log('[FixedBandle] getFirstTierEffectivePrice → price:', firstTier.price);
            return parseFloat(firstTier.price || Infinity);
        },

        /**
         * Find the SKU with the lowest effective first-tier price among all SKUs.
         * This ensures the bundle always starts with the cheapest possible tier.
         */
        getLowestFirstTierSku(configurable_array) {
            let lowestPrice = Infinity;
            let lowestSku = null;

            Object.keys(configurable_array).forEach(sku => {
                const tierPrices = configurable_array[sku]?.prices_2?.tier_price;
                const effectivePrice = this.getFirstTierEffectivePrice(tierPrices);

                console.log('[FixedBandle] SKU:', sku, '→ first tier effective price:', effectivePrice);

                if (effectivePrice < lowestPrice) {
                    lowestPrice = effectivePrice;
                    lowestSku = sku;
                }
            });

            console.log('[FixedBandle] Selected lowest SKU:', lowestSku, 'price:', lowestPrice);
            return lowestSku;
        },

        setTierData(sku = null) {

            let configurable_array = this.full_product.configurable_array;
            if(!sku) {
                // Instead of blindly taking the first key, find the SKU
                // with the lowest effective first-tier price (sale or regular)
                sku = this.getLowestFirstTierSku(configurable_array);
                if (!sku) {
                    sku = Object.keys(configurable_array)[0]; // fallback
                }
            }
            console.warn("setTierData");
            console.log(sku);
            console.log(this.full_product.configurable_array[sku]);

            this.tier_data = this.full_product.configurable_array[sku].prices_2.tier_price;
            this.store.prices.tier = this.tier_data;

            console.error(">>>>>>>>>>> setTierData >>>>>>>>>");
            console.log(this.tier_data);
            console.error(">>>>>>>>>>> setTierData 2222222222 >>>>>>>>>");
            console.warn(this.store.prices.tier);
            return this.store.prices.tier;
        },
        goToCustomizePage(event){
            event.preventDefault();

            if(this.totalQty >= this.minBundleQty) {

                console.error("click go to customize");
                console.warn(this.store.bandleProductLists)

                let storageProductList = [];
                let stringProductList = ''; // 8535636115733_8535636115733_8535636115733
                let productsCount = this.store.bandleProductLists.length;
                let separator = '_';

                this.store.bandleProductLists.forEach( (product, index ) => {
                    storageProductList.push(
                        {
                            id: product.id,
                            qty: product.qty
                        }
                    );

                    // TODO need improve
                    if (productsCount == 1 && index == 0) {
                        console.warn("first");
                        stringProductList += product.id;
                    } else if (productsCount > 1 && (productsCount - 1) !== index) {
                        console.warn("middle");
                        stringProductList += product.id + separator;
                    } else if ( productsCount > 1 && (productsCount - 1) == index) {
                        console.warn("third");
                        stringProductList += product.id;
                    }
                });

                console.log(storageProductList);

                this.storageService.setToLocalStorageByKey("storageProductList", storageProductList);
                this.storageService.setToLocalStorageByKey("fullStorageProductList", this.store.bandleProductLists);

                console.error("goToCustomizePage clicked");
                console.warn(stringProductList);
                window.location.href = window.location.origin + "/collections/calendar-bundle-custom?bundleList=" + stringProductList;
            }

        },
        /**
         * Check if sale price is valid based on current date
         * Ported from ReviewSection.vue (vue-imprint-app-product-page)
         * @param {Object} tier - Tier price object
         * @returns {boolean}
         */
        isSalePriceValid(tier) {
            if (!tier.sale_price) {
                return false;
            }

            if (!tier.sale_price_effectivedate || !tier.sale_price_terminationdate) {
                console.warn('[FixedBandle] Sale price missing dates, using regular price', tier);
                return false;
            }

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const effectiveDate = new Date(tier.sale_price_effectivedate);
            effectiveDate.setHours(0, 0, 0, 0);

            const terminationDate = new Date(tier.sale_price_terminationdate);
            terminationDate.setHours(23, 59, 59, 999);

            const isValid = today >= effectiveDate && today <= terminationDate;

            console.log('[FixedBandle] Sale price date check:', {
                today: today.toISOString().split('T')[0],
                effectiveDate: tier.sale_price_effectivedate,
                terminationDate: tier.sale_price_terminationdate,
                isValid
            });

            return isValid;
        },

        calculatePriceByQty(totalQty) {
            let priceByQty = 0.00;
            console.error(" #### BUNDLE STORE ###>>>>");
            console.log(this.store);
            console.error("calculatePriceByQty");
            console.log(totalQty);
            console.log("this.store.prices.tier >>>>> ");
            console.log(this.store.prices.tier);

            if (Number.parseFloat(totalQty) < 1) {
                this.store.priceByQty = 0.00;
                this.priceByQty = 0.00;
                return 0.00;
            }

            if (!this.store.prices.tier || !this.store.prices.tier.length) {
                console.warn('[FixedBandle] No tier data available');
                return priceByQty;
            }

            // Filter out MSRP rows and sort by QtyMin descending (highest first)
            // to find the best matching tier (same logic as ReviewSection.vue)
            const validTiers = [...this.store.prices.tier]
                .filter(item => item.QtyMin !== 'MSRP')
                .sort((a, b) => Number(b.QtyMin || 0) - Number(a.QtyMin || 0));

            // Find first tier where totalQty >= QtyMin
            let matchedTier = null;
            for (const tier of validTiers) {
                if (Number.parseFloat(totalQty) >= Number.parseFloat(tier.QtyMin || 0)) {
                    matchedTier = tier;
                    break;
                }
            }

            // If no tier matched, fall back to the lowest tier (last in sorted desc = first in original)
            if (!matchedTier) {
                matchedTier = validTiers[validTiers.length - 1] || this.store.prices.tier[0];
            }

            if (matchedTier) {
                if (this.isSalePriceValid(matchedTier)) {
                    priceByQty = parseFloat(matchedTier.sale_price);
                    console.log('[FixedBandle] Using VALID sale_price:', priceByQty, 'for qty:', totalQty);
                } else {
                    priceByQty = parseFloat(matchedTier.price || 0);
                    console.log('[FixedBandle] Using regular price:', priceByQty, 'for qty:', totalQty, '(sale not valid)');
                }
            }

            console.log('[FixedBandle] Final priceByQty:', priceByQty);

            this.store.priceByQty = priceByQty;
            this.priceByQty = priceByQty;

            return priceByQty;
        },
        calculateTotalQty() {
            let totalQty = 0;

            this.store.bandleProductLists.forEach( product => {
                totalQty += parseInt(product.qty);
            });

            this.store.calendarsTotalQty = totalQty;
            this.totalQty = totalQty;

            return totalQty;
        },
        /**
         *
         * @param {*} qtyObj
         * @param {*} flag update|add|recalculate
         */
        onQtyUpdated(qtyObj, flag = 'update') {
            console.error("Qty updated in bundle");
            console.log(qtyObj.value);
            console.error("Product index in store >>>>>>>");
            console.warn(qtyObj.prIndex);
            console.warn(qtyObj.prID);
            console.error("!!!!!!!!! this.store.bandleProductLists");
            console.warn(this.store.bandleProductLists);
            if(flag === 'update') {
                console.log(this.store.bandleProductLists[qtyObj.prIndex]);
            }
            console.error(flag);

            /**
             * update to recived value qtyObj.values
             */
            if(flag === 'update') {
                this.store.bandleProductLists[qtyObj.prIndex].qty = parseInt(qtyObj.value);
            }

            let totalQty = this.calculateTotalQty();
            let priceByQty = this.calculatePriceByQty(totalQty);

            if(flag === 'update') {
                this.store.bandleProductLists[qtyObj.prIndex].unitPrice = priceByQty;
            }
            this.storageService.setToLocalStorageByKey("fullStorageProductList", this.store.bandleProductLists);
            
            this.updateImprintQty(totalQty);
        },
        updateImprintQty(value) {
            if(window.jQuery("#calendar-qty-changed") && window.jQuery("#calendar-imprint-common-qty")) {
                window.jQuery("#calendar-imprint-common-qty").val(value);
                window.jQuery("#calendar-qty-changed").trigger("click");
            }
        },
        /**
         *
         * @param {*} prID
         * @returns {index} (0-...) Number
         */
        getIndexByProductID(prID) {
            let result = null;
            this.store.bandleProductLists.forEach(
                (product, index) => {
                    console.warn("Loop");
                    console.warn(typeof product.id);
                    console.warn(typeof prID);
                    if (product.id == prID) {
                        result = index;
                    }
                }
            );
            return result;
        },
        changeProductList(product = {}) {
            let indexFromStorage = this.getIndexByProductID(product.id);
            let actionFlag = 'add';

            console.error(">>>>>>>>>>>>!!!!!!!!&&&&&&%%%^^^^^&&&&&&***???????");
            console.warn(typeof indexFromStorage);
            console.warn(indexFromStorage);
            /**
             * if current product id is saved then update only qty
             * TODO not see .push();
             */

            if (indexFromStorage === null && product) {
                console.error("########### Iffff index from storage >>>>>");
                actionFlag = 'add';
                // Push new product to store
                this.store.bandleProductLists.push(product);
                this.onQtyUpdated(
                    {
                        value: parseInt(product.qty),
                        prIndex: indexFromStorage,
                        prID: product.id
                    },
                    actionFlag
                );

                this.isCalBundlleOpened = true;
                this.hasBundleProducts = true;
            } else {
                let localStorageData = this.storageService.getFromLocalStorageByKey("fullStorageProductList");
                let value_before = parseInt(localStorageData[indexFromStorage]['qty']);
                let value_add = parseInt(product.qty);
                actionFlag = 'update';

                console.error("########### Else 3 index from storage >>>>>");

                this.onQtyUpdated(
                    {
                        value:  value_before + value_add,
                        prIndex: indexFromStorage,
                        prID: product.id
                    },
                    actionFlag
                );

                this.isCalBundlleOpened = true;
                this.hasBundleProducts = true;
            }
        },
        onImprintMethodChange(imprint_sku) {
            console.error("Imprint tab clicked");

            if(imprint_sku) {
                let setImprintResult = this.setTierData(imprint_sku);

                if(Object.keys(setImprintResult).length) {
                    this.onQtyUpdated({value: 0, prIndex: 0, prID: 0 }, 'recalculate');
                }
            }
        },

        getProductItemInfoFromCollectionPage(productID, mainElement, cCollectionSearchOptions = null) {
            let collectionSearchOptions = cCollectionSearchOptions;
            if(!collectionSearchOptions) {
                collectionSearchOptions = '.product-details.product-details-custom > a > span.title';
            }

            /**
             * if we have product id, recive full json data
             */
            if(productID) {
                this.initFullJsonData(productID);
            }
            if(!productID) {
                console.error("productID required, please check. Current value: " + productID + " typeof: " + typeof productID + " !!!");
            }

            let productImage = '';
            /*** get productImage url when click on button "add to bundle" collection page and single page */
            if(mainElement.find('.image-element__wrap > img').length) {
                productImage = window.jQuery(mainElement.find('.image-element__wrap > img')[0]).attr('src');
            } else {
                productImage = window.jQuery(window.jQuery(".image__container > .zoom-container > img.zoomImg")[0]).attr('src');
            }

            if(!productImage) {
                console.error("productImage required, please check. Current value: " + productImage + " typeof: " + typeof productImage + " !!!");
            }
           
            let productTitle = '';
            /*** get productTitle when click on button "add to bundle" collection page and single page */
            if(mainElement.find(collectionSearchOptions).length) {
                productTitle =  mainElement.find(collectionSearchOptions)[0].innerText;
            } else {
                productTitle = window.jQuery("h1.product_name.product_top_name")[0].innerText;
            }
            
            if(!productTitle) {
                console.error("productTitle required, please check. Current value: " + productTitle + " typeof: " + typeof productTitle + " !!!");
            }
            
            let productQty = '';
            /*** get productQty when click on button "add to bundle" collection page and single page */ 
            if(mainElement.find('.size-row__input.size-row__input--add-to-bundle').length) {
                productQty = mainElement.find('.size-row__input.size-row__input--add-to-bundle')[0].value;
            } else {
                productQty = window.jQuery(".bundle-butons__item.bundle-butons__item--qty input.size-row__input")[0].value;
            }

            if(!productQty) {
                console.error("productQty required, please check. Current value: " + productQty + " typeof: " + typeof productQty + " !!!");
            }
            if(productQty < this.qtyIterator) {
                productQty = this.qtyIterator;
            }

            return {
                id: productID,
                image: productImage,
                title: productTitle,
                qty: productQty,
                unitPrice: 1.75
            };

        },

        initFullJsonData(args = 'calendar-gruped', mode = false) {
            if(!mode) {
                this.getWallFullProductJson(args);
            } else {
                this.getFullProductJson(args);
            }
        },

        initSingleProductPage() {
            console.log("init single product page");
            this.initFullJsonData('calendar-gruped');

            // Use body event delegation (works even if button doesn't exist yet)
            window.jQuery("body").on("click", ".add_to_cart_type_class--bundle", (e) => {
                e.preventDefault();
                console.error("Single product clicked");
                let singlePrBtn = window.jQuery(e.target);
                if(singlePrBtn) {
                    this.singlePrItem.id = singlePrBtn.data("product_id");
                    this.singlePrItem.title = singlePrBtn.data("product_title");
                    this.singlePrItem.image = singlePrBtn.data("product_image");
                    this.singlePrItem.qty = window.jQuery("#size-input-single-" + this.singlePrItem.id).val();
                }
                console.warn("FFFFFFFFFFFFFF++++++++>>>>>> After Single product clicked: >>>>>");
                console.log(this.singlePrItem);

                this.changeProductList(this.singlePrItem);
            });

            // Add handler for imprint tabs
            window.jQuery("body.product").on("click", ".c-tabs button.c-tabs__btn_js", (e) => {
                let imprint_sku = window.jQuery(e.target).data("imprint_sku");
                this.onImprintMethodChange(imprint_sku);
            });
        },
        initCollectionPage() {
            console.log("init collection product page");
                window.jQuery("body").on("click", ".add_to_cart_type_class--bundle", (e) => {
                        e.preventDefault();
                        console.error("clicked");
                        console.log(this);
                        console.warn(window.jQuery(e.target).data("product_id"));
                        if(!window.jQuery(e.target).hasClass("btn-disabled")) {
                            let currentEl = window.jQuery(e.target);
                            let productID = currentEl.data("product_id");
                            let mainWrapperClass = "product-main-wrap-" + productID;
                            let mainElement = window.jQuery('.' + mainWrapperClass).clone();

                            let collectionQuery = null;
                            if(window.location.pathname == "/collections/calendars") {
                                //'.product-details.product-details-custom > span.title';
                                collectionQuery = ".product-details.product-details-custom > a > span.title";
                            } else {
                                collectionQuery = ".product-details.product-details-custom > a > span.title";
                            }

                            let productItem = this.getProductItemInfoFromCollectionPage(productID, mainElement, collectionQuery);

                            if((productItem.qty % this.qtyIterator) == 0) {
                                let indexFromStorage = this.getIndexByProductID(productID);
                                let actionFlag = "";

                                /**
                                 * if current product id is saved then update only qty
                                 * TODO not see .push();
                                 */
                                if (indexFromStorage === null ) {
                                    actionFlag = 'add';
                                    this.store.bandleProductLists.push(productItem);
                                    
                                    this.onQtyUpdated(
                                        {
                                            value: parseInt(productItem.qty),
                                            prIndex: indexFromStorage, 
                                            prID: productID
                                        },
                                        actionFlag
                                    );

                                    this.isCalBundlleOpened = true;
                                    this.hasBundleProducts = true;

                                } else {
                                    actionFlag = 'update';
                                    console.error("###########3 index from storage >>>>>");
                                    console.warn(indexFromStorage);
                                    console.warn(typeof indexFromStorage);
                                    console.warn(this.store.bandleProductLists[indexFromStorage].qty);
                                    console.error(parseInt(this.store.bandleProductLists[indexFromStorage].qty) + parseInt(productItem.qty));

                                    this.onQtyUpdated(
                                        {
                                            value: parseInt(this.store.bandleProductLists[indexFromStorage].qty) + parseInt(productItem.qty),
                                            prIndex: indexFromStorage, 
                                            prID: productID
                                        },
                                        actionFlag
                                    );

                                    this.isCalBundlleOpened = true;
                                    this.hasBundleProducts = true;
                                
                                }
                            }
                        }
                    });

        },
        initCustomBundlePage() {
            this.initFullJsonData('calendar-gruped');

            window.jQuery("body.product").on("click", ".c-tabs button.c-tabs__btn_js", (e) => {
                let imprint_sku = window.jQuery(e.target).data("imprint_sku");
                this.onImprintMethodChange(imprint_sku);
            });
        },
        setDefaultActiveImprintMethod() {
            let imprintMethodElements = window.jQuery(".c-tabs button.c-tabs__btn_js");

            if(imprintMethodElements.length) {
                imprintMethodElements.each(
                    function() {
                        if(window.jQuery(this).hasClass("c-tabs__btn--active")) {
                            window.jQuery(this).click();
                        }
                    }
                );
            }

        }
    },
    created() {
        console.error("######################### Calendar Bundle CREATED ######################################");
        this.initFullJsonData();

        // Show aplication store state
        console.warn("++++++++++++ STORE +++++++++++++");
        console.log(this.store);

        /*** Start init type of bundle page */
        let singleCalendarBundleTag = false;
        let isCustomBundlePage = false;
        //let isCalendarCategory = false;

        if(document.getElementById("it-is-bundle-product")) {
            singleCalendarBundleTag = document.getElementById("it-is-bundle-product").textContent;
            let bodyProduct = window.jQuery("body.product");
            if(singleCalendarBundleTag && bodyProduct.length) {
                singleCalendarBundleTag = true;
            } else {
                singleCalendarBundleTag = false;
            }
            console.error("!!!!!! >>> BundleSingle Product <<<<<<");
            console.log(singleCalendarBundleTag);
        }
        if(document.getElementById("it-is-bundle-custom-page")) {
            let customPageBundleTag = document.getElementById("it-is-bundle-custom-page").textContent;

            if(customPageBundleTag) {
                isCustomBundlePage = true;
            }
        }
        /*** End init type of bundle page */

        /********* Start Init Pages */
        if(isCustomBundlePage) {
            this.initCustomBundlePage();
            console.error("!!!!!! >>> if isCustomBundlePage <<<<<<");
        } else if(singleCalendarBundleTag) {
            console.error("!!!!!! >>> else if singleCalendarBundleTag <<<<<<");
            this.initSingleProductPage();
        }
        if(!isCustomBundlePage && !singleCalendarBundleTag) {
            console.error("!!!!!! >>> else Bundle Collection Page <<<<<<");

            /**
            * if we have product id, recive full json data
            */
            this.initCollectionPage();
        }
        /********* End InitPages *******/

        /**** Start Add handler to imprint tabs in Imprrin Aplication */

        window.jQuery("body.collection-calendar-bundle-custom").on("click", ".c-tabs button.c-tabs__btn_js", (e) => {
            let imprint_sku = window.jQuery(e.target).data("imprint_sku");
            this.onImprintMethodChange(imprint_sku);
        });
        /**** End Add handler to imprint tabs in Imprrin Aplication */

        console.warn("++++++++++++ getFromLocalStorageByKey(fullStorageProductLists) +++++++++++++");
        console.warn(this.storageService.getFromLocalStorageByKey("fullStorageProductList"));
        console.warn(this.storageService.getFromLocalStorageByKey("fullStorageProductList"));

        /*** Check Saved localStorage data 'fullStorageProductList' and init hasBundleProducts */
        if(this.storageService.getFromLocalStorageByKey("fullStorageProductList").length) {
            this.store.bandleProductLists = this.storageService.getFromLocalStorageByKey("fullStorageProductList");
                console.error("!!!!!! >>> Bundle Local storage <<<<<<");
                console.log(this.store.bandleProductLists);
            if(this.store.bandleProductLists.length) {
                this.store.bandleProductLists.forEach(
                    (value, index) => {
                        this.onQtyUpdated({value: value.qty, prIndex: index, prID: value.id }, 'recalculate');
                    }
                );
                this.hasBundleProducts = true;
            } else {
                this.hasBundleProducts = false;
            }
        }

        /*** End Check Saved localStorage data 'fullStorageProductList' and init hasBundleProducts */
        window.jQuery("#add-to-cart-complited").on("click", 
            () => {
                this.store.bandleProductLists = [];
                this.hasBundleProducts = false;
                this.totalQty = 0;
            }
        );
        setTimeout(
            () => {
                this.setDefaultActiveImprintMethod();
        }, 100);

    }
}


</script>

<style>
/* Fonts Start */
/*
 * The Typekit service used to deliver this font or fonts for use on websites
 * is provided by Adobe and is subject to these Terms of Use
 * http://www.adobe.com/products/eulas/tou_typekit. For font license
 * information, see the list below.
 *
 * museo:
 *   - http://typekit.com/eulas/00000000000000007735993f
 *   - http://typekit.com/eulas/000000000000000000011b23
 *   - http://typekit.com/eulas/000000000000000077359947
 *   - http://typekit.com/eulas/000000000000000000011b24
 *   - http://typekit.com/eulas/000000000000000077359958
 *   - http://typekit.com/eulas/00000000000000007735997d
 *   - http://typekit.com/eulas/000000000000000077359969
 *   - http://typekit.com/eulas/000000000000000077359952
 *   - http://typekit.com/eulas/000000000000000077359949
 *   - http://typekit.com/eulas/000000000000000077359967
 * museo-sans:
 *   - http://typekit.com/eulas/00000000000000000000e800
 *   - http://typekit.com/eulas/00000000000000000000e801
 *   - http://typekit.com/eulas/00000000000000000000e7fe
 *   - http://typekit.com/eulas/00000000000000000000e802
 *   - http://typekit.com/eulas/00000000000000000000e803
 *   - http://typekit.com/eulas/00000000000000000000e804
 *   - http://typekit.com/eulas/00000000000000000000e805
 *   - http://typekit.com/eulas/00000000000000000000e806
 *   - http://typekit.com/eulas/00000000000000000000e807
 *   - http://typekit.com/eulas/00000000000000000000e808
 * museo-sans-condensed:
 *   - http://typekit.com/eulas/000000000000000000012ca6
 *   - http://typekit.com/eulas/000000000000000000012ca7
 *   - http://typekit.com/eulas/000000000000000000012caa
 *   - http://typekit.com/eulas/000000000000000000012cab
 *   - http://typekit.com/eulas/000000000000000077359968
 *   - http://typekit.com/eulas/00000000000000007735994d
 *   - http://typekit.com/eulas/000000000000000000012ca8
 *   - http://typekit.com/eulas/000000000000000000012ca9
 *   - http://typekit.com/eulas/00000000000000007735995c
 *   - http://typekit.com/eulas/00000000000000007735995d
 *
 * © 2009-2023 Adobe Systems Incorporated. All Rights Reserved.
 */
/*{"last_published":"2023-02-01 21:24:01 UTC"}*/

@import url("https://p.typekit.net/p.css?s=1&k=fzx7sjl&ht=tk&f=1980.1981.1982.1983.1984.8541.8542.8543.8544.8545.2003.2004.2005.2006.2007.2008.2009.2010.2011.2012.17398.17399.17400.17401.17402.17403.17404.17405.17406.17407&a=86896830&app=typekit&e=css");

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/38974e/00000000000000007735993f/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("woff2"),url("https://use.typekit.net/af/38974e/00000000000000007735993f/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("woff"),url("https://use.typekit.net/af/38974e/00000000000000007735993f/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:100;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/f7c91f/000000000000000000011b23/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff2"),url("https://use.typekit.net/af/f7c91f/000000000000000000011b23/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff"),url("https://use.typekit.net/af/f7c91f/000000000000000000011b23/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/d23205/000000000000000077359947/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff2"),url("https://use.typekit.net/af/d23205/000000000000000077359947/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff"),url("https://use.typekit.net/af/d23205/000000000000000077359947/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/8a79e7/000000000000000000011b24/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/8a79e7/000000000000000000011b24/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/8a79e7/000000000000000000011b24/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/12040f/000000000000000077359958/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff2"),url("https://use.typekit.net/af/12040f/000000000000000077359958/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff"),url("https://use.typekit.net/af/12040f/000000000000000077359958/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/088ff9/00000000000000007735997d/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("woff2"),url("https://use.typekit.net/af/088ff9/00000000000000007735997d/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("woff"),url("https://use.typekit.net/af/088ff9/00000000000000007735997d/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:100;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/64e458/000000000000000077359969/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff2"),url("https://use.typekit.net/af/64e458/000000000000000077359969/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff"),url("https://use.typekit.net/af/64e458/000000000000000077359969/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/2dc4e0/000000000000000077359952/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff2"),url("https://use.typekit.net/af/2dc4e0/000000000000000077359952/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff"),url("https://use.typekit.net/af/2dc4e0/000000000000000077359952/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/3e30bd/000000000000000077359949/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"),url("https://use.typekit.net/af/3e30bd/000000000000000077359949/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"),url("https://use.typekit.net/af/3e30bd/000000000000000077359949/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/eaeb90/000000000000000077359967/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff2"),url("https://use.typekit.net/af/eaeb90/000000000000000077359967/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff"),url("https://use.typekit.net/af/eaeb90/000000000000000077359967/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/635674/00000000000000000000e800/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("woff2"),url("https://use.typekit.net/af/635674/00000000000000000000e800/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("woff"),url("https://use.typekit.net/af/635674/00000000000000000000e800/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:100;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/47003b/00000000000000000000e801/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("woff2"),url("https://use.typekit.net/af/47003b/00000000000000000000e801/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("woff"),url("https://use.typekit.net/af/47003b/00000000000000000000e801/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:100;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/620bf8/00000000000000000000e7fe/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff2"),url("https://use.typekit.net/af/620bf8/00000000000000000000e7fe/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff"),url("https://use.typekit.net/af/620bf8/00000000000000000000e7fe/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/5cca6d/00000000000000000000e802/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff2"),url("https://use.typekit.net/af/5cca6d/00000000000000000000e802/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff"),url("https://use.typekit.net/af/5cca6d/00000000000000000000e802/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/a28b50/00000000000000000000e803/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff2"),url("https://use.typekit.net/af/a28b50/00000000000000000000e803/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff"),url("https://use.typekit.net/af/a28b50/00000000000000000000e803/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/c2d3de/00000000000000000000e804/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff2"),url("https://use.typekit.net/af/c2d3de/00000000000000000000e804/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff"),url("https://use.typekit.net/af/c2d3de/00000000000000000000e804/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/e3ca36/00000000000000000000e805/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/e3ca36/00000000000000000000e805/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/e3ca36/00000000000000000000e805/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/2841b6/00000000000000000000e806/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"),url("https://use.typekit.net/af/2841b6/00000000000000000000e806/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"),url("https://use.typekit.net/af/2841b6/00000000000000000000e806/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/9cf49e/00000000000000000000e807/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff2"),url("https://use.typekit.net/af/9cf49e/00000000000000000000e807/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff"),url("https://use.typekit.net/af/9cf49e/00000000000000000000e807/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/27c143/00000000000000000000e808/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff2"),url("https://use.typekit.net/af/27c143/00000000000000000000e808/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff"),url("https://use.typekit.net/af/27c143/00000000000000000000e808/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/da6ab2/000000000000000000012ca6/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff2"),url("https://use.typekit.net/af/da6ab2/000000000000000000012ca6/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff"),url("https://use.typekit.net/af/da6ab2/000000000000000000012ca6/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/f58f65/000000000000000000012ca7/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff2"),url("https://use.typekit.net/af/f58f65/000000000000000000012ca7/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff"),url("https://use.typekit.net/af/f58f65/000000000000000000012ca7/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/592eea/000000000000000000012caa/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/592eea/000000000000000000012caa/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/592eea/000000000000000000012caa/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/9c0805/000000000000000000012cab/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"),url("https://use.typekit.net/af/9c0805/000000000000000000012cab/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"),url("https://use.typekit.net/af/9c0805/000000000000000000012cab/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/ac10d8/000000000000000077359968/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("woff2"),url("https://use.typekit.net/af/ac10d8/000000000000000077359968/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("woff"),url("https://use.typekit.net/af/ac10d8/000000000000000077359968/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:100;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/da67ed/00000000000000007735994d/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("woff2"),url("https://use.typekit.net/af/da67ed/00000000000000007735994d/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("woff"),url("https://use.typekit.net/af/da67ed/00000000000000007735994d/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:100;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/514cc2/000000000000000000012ca8/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff2"),url("https://use.typekit.net/af/514cc2/000000000000000000012ca8/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff"),url("https://use.typekit.net/af/514cc2/000000000000000000012ca8/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/a84d3d/000000000000000000012ca9/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff2"),url("https://use.typekit.net/af/a84d3d/000000000000000000012ca9/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff"),url("https://use.typekit.net/af/a84d3d/000000000000000000012ca9/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/87c5cb/00000000000000007735995c/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff2"),url("https://use.typekit.net/af/87c5cb/00000000000000007735995c/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff"),url("https://use.typekit.net/af/87c5cb/00000000000000007735995c/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/6b043a/00000000000000007735995d/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff2"),url("https://use.typekit.net/af/6b043a/00000000000000007735995d/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff"),url("https://use.typekit.net/af/6b043a/00000000000000007735995d/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:900;font-stretch:normal;
}

/* Fonts End */
.calendar-bundle__head {
    width:100%;
    color: #fff;
    height: 110px;
    display: flex;
    justify-content: center;
}

.calendar-bundle__body, .calendar-bundle__footer  {
    background: #fff;
    z-index: 999;
    justify-content: center;
    display: flex;
    width: 100%;
}

.calendar-bundle__body-wrap {
    flex-direction: column;
    border-bottom: 1px solid #595959;
    width: 1000px;
}

.calendar-bundle__footer-wrap {
    justify-content: space-between !important;
    max-width: 1250px !important;
    width: 1000px;
}

.calendar-bundle__head-wrap,
.calendar-bundle__body-wrap,
.calendar-bundle__footer-wrap {
    display: flex;
    max-width: 1124px;
    width: 1000px;
    justify-content: space-around;
    padding: 20px 0;
}

.calendar-bundle__head-text--big {
    font-weight: 700;
    font-size: 28px;
    text-align: -webkit-left;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    line-height: 28px;
}

.calendar-bandle__head-text--small {
    font-family: "museo-sans", sans-serif;
    font-size: 14px;
    font-weight: 300;
    line-height: 21px;
}
.calendar-bundle__head-text--small-yellow {
    color: #FFCD05;
    font-family: "museo-sans", sans-serif;
    font-size: 14px;
    font-weight: 300;
    line-height: 21px;
}
.calendar-bundle__head-col {
    max-width: 45%;
    width: 45%;
    display: flex;
    flex-direction: column;
    align-items: start;
}
.calendar-bundle__head-col.calendar-bundle__head-col--btn {
    justify-content: center;
    align-items: end;
    font-family: "museo-sans", sans-serif;
    font-weight: 800;
    font-size: 12px;
}
.mlp-calendar-bundle__head-button {
    background-color: #FFCD05;
    border: 1px solid #FFCD05;
    color: #ffffff;
    border-radius: 5px;
    padding: 5px 20px;
}
.mlp-calendar-bundle__head-button:hover {
    background-color: #FCB315;
    color: #ffffff;
    border: 1px solid #FCB315;
    border-radius: 5px;
}
.comda-calendar-bundle__head-button {
  background-color: #f8c22c;
  border: 1px solid #f8c22c;
  color: #1754a3;
  border-radius: 5px;
  padding: 5px 20px;
  font-weight: 800;
  font-family: 'Open Sans', 'Helvetica Neue', Verdana, Arial, sans-serif;
}
.comda-calendar-bundle__head-button:hover {
  background-color: #1754a3;
  color: #f8c22c;
  border: 1px solid #f8c22c;
  border-radius: 5px;
  text-decoration: underline;
}
#c-calendar-bandle {
    position: fixed;
    width: 100%;
    height: auto;
    left: 0;
    bottom: 0;
    z-index: 999;
}
.mlp-calendar-bundle__body-items {
    display: flex;
    flex-direction: column;
}
.comda-mlp-calendar-bundle__body-items {
  display: flex;
  flex-direction: column;
  font-family: 'Open Sans', serif;
}
.mlp-calendar-bundle__body-title {
    color: #009444;
    font-weight: bold;
    font-size: 20px;
}
.comda-calendar-bundle__body-title {
  color: #0054a3;
  font-weight: bold;
  font-size: 20px;
  font-family: 'Oswald', Verdana, Arial, sans-serif;
  margin-bottom: 7px;
}
.calendar-bundle__list-text {
    color: black;
    margin-left: 10px;
    font-weight: 800;
    font-family: 'oswald', sans-serif;
    font-size: 16px;
}

.calendar-bundle__list-sub_text{
    font-size: 12px;
    margin-left: 20px;
    color: black;
    font-weight: 800;
    font-family: 'oswald', sans-serif;
}
.calendar-bundle__list--bottom-text {
    color: black;
    margin-left: 10px;
    font-weight: 800;
    font-family: 'oswald', sans-serif;
    font-size: 14px;
}
.calendar-bundle__body-items-list.calendar-bundle__list{
    list-style-type: none;
    padding-left: 10px;
}
.calendar-bundle__footer-btn {
    border-radius: 5px;
    padding: 8px 23px;
    font-size: 12px;
    float: left;
    margin-right: 15px;
    background-color: #009444;
    color: #fff;
    font-family: "Montserrat", sans-serif;
    font-size: 12px;
    white-space: nowrap;
}
.calendar-bundle__footer-text {
    margin-top: 7px;
    font-size: 14px;
    font-family: 'museo-sans', sans-serif;
    font-weight: 300;
    color: #5A5A5A;
    width: 75%;
}
.calendar-bundle__footer-calc-list {
    list-style-type: none;
    padding-left: 10px;
    margin: 0 !important;
}
.calendar-bundle__footer-calc-list li {
    margin-bottom: 0 !important;
}
.calendar-bundle__footer-calc {
    width: 25%;
}
.mlp-footer-calc-list-item__key {
    font-family: 'Open Sans', 'Helvetica Neue', Verdana, Arial, sans-serif;
    font-weight: 600;
    font-size: 12px;
    color: #009444 !important;
}
.comda-footer-calc-list-item__key {
  font-family: 'Open Sans', 'Helvetica Neue', Verdana, Arial, sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: #0054a3 !important;
}
.footer-calc-list-item__val {
    color: black;
    font-weight: 700;
    transition: color 500ms;
    font-family: 'Open Sans', 'Helvetica Neue', Verdana, Arial, sans-serif !important;
    font-weight: 600;
    font-size: 12px;
    margin-left:5px;
}
.bandle-products .bandle-products__item .image-element__wrap img {
    height: 100% !important;
    width: auto !important;
}

.bandle-products .bandle-products__item .image__container {
    display: flex;
    height: 175px;
}

.bandle-products .bandle-products__item {
    display: flex;
    flex-direction: column;
    width: 200px;
}

.bandle-products .bandle-products__item a[type="submit"] {
    font-weight: 300;
    max-height: 30px;
    height: 30px;
    padding: unset!important;
}
.bandle-products {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}
.bandel-item-wrapp .bandle-products__item .product-details.product-details-custom {
    padding: 10px 5px 0 5px;
    display: flex;
    justify-content: center;
}

.calendar-bundle__footer-btn.calendar-bundle__footer-btn--disabled {
    background: #C8C8C8;
    opacity: 0.6;
    cursor: not-allowed;
}
.comda-calendar-bundle__body-items .calendar-bundle__body-items-list .calendar-bundle__list-text{
    font-family: "Open Sans",sans-serif;
    font-size: 16px;
    font-weight: 800;
    line-height: 24px;
    margin-bottom: 0;
    color: black;
}
.comda-calendar-bundle__body-items .calendar-bundle__body-items-list li{
    margin-bottom: 0;
}

.comda-calendar-bundle__body-items .calendar-bundle__body-items-list .calendar-bundle__list-sub_text{
    font-size: 12px;
    margin-left: 20px;
    font-family: "Open Sans",sans-serif;
    font-weight: 800;
    color: black;
}

.comda-calendar-bundle__body-items .calendar-bundle__list--bottom-text{
    margin-top: 15px;
    font-family: 'Open Sans', 'Helvetica Neue', Verdana, Arial, sans-serif;
    color: black;
}

.comda .calendar-bundle__head-wrap{
    width: 1124px;
    justify-content: space-between;
}

.comda .calendar-bundle__footer-btn{
    text-transform: uppercase;
    font-family: 'Open Sans', 'Helvetica Neue', Verdana, Arial, sans-serif ;
    background-color: #0054a3;
}

.comda .calendar-bundle__head-text--small{
    margin-left: 9px;
}

.comda .calendar-bundle__footer-text{
    font-family: 'Open Sans', 'Helvetica Neue', Verdana, Arial, sans-serif ;
    color: #898989;
}
.comda .calendar-bundle__footer-calc-list{
    line-height: 18px;
}
.comda .footer-calc-list-item__val{
    margin-left: 0;
    font-weight: 700;
}
.comda .calendar-bundle__head-text--small{
    font-size: 14px;
    line-height: 21px;
    font-family: 'Open Sans', 'Helvetica Neue', Verdana, Arial, sans-serif !important;
}
.comda .btn-remove:after{
    color: #0054a3;
}
.comda .btn-remove:hover{
    background-color: #0054a3;
    color: #fff;
}
.comda .btn-remove:hover:after{
    color: #fff;
}

.calendar-bundle__head-text--big {
    font-size: 28px;
    font-weight: 700;
}

@media only screen and (min-width: 1025px) and (max-width: 1124px) {
    .calendar-bundle__head-wrap {
        padding: 20px 30px;
    }
}

@media screen and (max-width: 1224px) {
    .calendar-bundle__head-wrap {
        width: 100% !important;
        padding: 15px 20px;
    }

    .calendar-bundle__head-col {
        width: 65%;
        max-width: none;
    }

    .calendar-bundle__head-wrap .calendar-bundle__head-col--btn {
        width: 255px;
    }

    .calendar-bundle__body-items-list.calendar-bundle__list {
        padding-left: 0;
    }
}

.mlp .calendar-bundle__head-col {
    max-width: 65%;
    width: 65%;
}
@media screen and (max-width: 1150px) {
    .calendar-bundle__body, .calendar-bundle__footer {
        padding: 0 45px;
    }
}
@media screen and (max-width: 1024px) {
    .mlp .calendar-bundle__head-wrap .calendar-bundle__head-col--btn {
        width: 270px !important;
    }
}

@media only screen and (min-width: 769px) and (max-width: 1124px) {
    .mlp .calendar-bundle__head-col {
        max-width: 65%!important;
        width: 65%!important;
    }
}

@media only screen and (min-width: 769px) and (max-width: 790px) {
    .mlp .calendar-bundle__head-col {
        max-width: 63%!important;
        width: 63%!important;
    }
    .mlp .calendar-bundle__head-text--small{
       font-size: 14px;
    }
}


@media screen and (max-width: 768px) {

    .calendar-bundle__head-col {
        display: inline-block;
        text-align: center;
        max-width: 100%!important;
    }

    .calendar-bundle__head-wrap .calendar-bundle__head-col--btn {
        margin-top: 15px;
    }

    .calendar-bundle__head-wrap {
        flex-direction: column;
        align-items: center;
    }

    .calendar-bundle__head .calendar-bundle__head-text--big {
        text-align: center;
    }


    .calendar-bundle__head {
        font-family: museo-sans, sans-serif;
        height: auto;
    }

    .calendar-bundle__head-text--big {
        justify-content: center !important;
    }

    .comda .calendar-bundle__head-text--small {
        margin-left: 0;
    }

    .calendar-bundle__footer-wrap div {
        order: 2;
    }

    .calendar-bundle__footer-wrap .calendar-bundle__footer-text {
        order: 1;
    }

    .calendar-bundle__footer-wrap .calendar-bundle__footer-calc {
        order: 3;
    }

    .calendar-bundle__footer-wrap {
        align-items: start;
    }

    .comda-footer-calc-list-item__key, .mlp-footer-calc-list-item__key {
        font-size: 16px;
        font-weight: 600;
    }

    .footer-calc-list-item__val {
        font-size: 16px;
        font-weight: 700;
    }

    .calendar-bundle__footer-calc {
        border-left: 1px solid black;
    }

    .calendar-bundle__footer-text {
        width: 30%;
    }

    .calendar-bundle__footer-wrap > div:nth-child(1) {
        margin: inherit;
    }

    .calendar-bundle__body-wrap {
        max-height: 160px;
        overflow-x: scroll;
    }
    .calendar-bundle__body-wrap.with-products{
        max-height: none;
    }

    #c-calendar-bandle {
        z-index: 2002 !important;
    }
    .calendar-bundle__footer-wrap {
        padding: 5px 0 0 0!important;
    }
     .calendar-bundle__footer-text{
         padding:  0 0 5px 0;
         margin-top: 0;
     }


}

@media screen and (max-width: 675px) {
    .calendar-bundle__head-col {
        width: 100% !important;
    }
}

@media screen and (max-width: 600px) {
    .calendar-bundle__head .calendar-bundle__head-text--big {
        font-size: 20px;
        line-height: 20px;
    }

    .comda-footer-calc-list-item__key, .mlp-footer-calc-list-item__key, .footer-calc-list-item__val {
        font-size: 13px;

    }

    .calendar-bundle__body, .calendar-bundle__footer {
        padding: 0 30px;
    }


}

@media screen and (max-width: 500px) {

}

@media screen and (max-width: 395px) {
    .calendar-bundle__head .calendar-bundle__head-text--big {
        text-align: left;
    }
}

.calendar-bundle__head-text--small{
    font-size: 15px;
    line-height: 24px;
}

.c-bandle-products__image-wrapper .btn-remove{
    border: none;
    -webkit-appearance: none;
    appearance: none;
    padding: 1px 6px;
}


</style>